module.exports = __webpack_public_path__ + "img/arrow-circle-broken-up.aa8ab09f.svg";